import React from "react";
// import ContactUs from "../ContactUs/ContactUs"
// import About from "../About/About";
import Products from "../Products/Products";
import Intro from "../Intro/Intro";
import all_products from "../Assets/all_products";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";
// import Questions from "../Questions/Questions";


function Home() {
    console.log(all_products)
    return(
        <>
        <div>

            <Intro/>
            <WhyChooseUs/>
            <Products />


            {/* <About/> */}
            {/* <ContactUs/> */}
            {/* <Questions/> */}
        </div>
        </>
    );
}
export default Home;